import { render, staticRenderFns } from "./pagamentoquota.vue?vue&type=template&id=9c4fa182&"
import script from "./pagamentoquota.vue?vue&type=script&lang=js&"
export * from "./pagamentoquota.vue?vue&type=script&lang=js&"
import style0 from "./pagamentoquota.vue?vue&type=style&index=0&id=9c4fa182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports